import { ThemeProvider } from "@mui/material";
import { PropsWithChildren } from "react";

import { encampTheme } from "../theme";

/**
 * App-wide MUI theme provider. Mode (light/dark) is managed by MUI's
 * color-scheme mechanism — read/changed via `useThemeMode()`. `noSsr`
 * because Oak is a client-only SPA. Defaults to light.
 */
export function EncampThemeProvider({ children }: PropsWithChildren) {
  return (
    <ThemeProvider theme={encampTheme} defaultMode="light" noSsr>
      {children}
    </ThemeProvider>
  );
}
